const en = {
        "welcome": "Welcome",
        "login": "Login",
        "home":{
           "seluncuran_air":`<span class="white anim">
                            Southeast Asia's
                        </span>
                        <span class="orange anim">
                            fastest and first
                        </span>
                        <span class="blue anim">water slide</span>`,
            "petualangan": `
                            <span class="white anim">An exciting water adventure</span>
                            <span class="blue anim"> for the whole family</span>
                            `,
            "temukan_petualangan":"Discover an exciting adventure with amazing rides and attractions",
            "min_tinggi":"Min. Height",
            "no_tinggi":"No. min height",
            "boomerango_desc":"Boomerango takes you through a dramatic tunnel of light rings, and straight onto a massive skateboard with a near-vertical launch. Enjoy the thrilling excitement of sliding with screams of joy.",
            "beli_langsung":"Buy directly and get the best prices!",
            "tiket":'Tickets',
            "sold_out":'Sold Out'
        },
        "getting_here":{
            "sub_heading":"To get to Wahoo Waterworld",
            "jam_buka": 'Opening Hours'
        },
        '404':'Page Not Found',
        'backHome':'Back to Home',
        "group_booking":{
            "sub_heading":"Wahoo Waterworld is the perfect venue for a special event, birthday, family outing or a group of friends looking to have some fun! Our team can help you with your enquiries and let you know our special rates and packages for groups over 50 people."
            ,"nama":"Name",
            "phone":"Phone",
            "event":"Select Event",
            "submit":"Submit"  
        },
        "plan_your_event":{
            "tarif_khusus":"Get our special rates and packages for groups of more than 50 people, Click the button on the Right"
        },
        "accomodation":{
            "sub_heading":"Visitors from outside Bandung can choose Mason Pine Hotel Bandung for a classy and comfortable accommodation, a hotel surrounded by beautiful natural scenery."
        },
        "dining":{
            "sub_heading":"Variety of eating places serving delicious food & fresh drinks!"
        },
        "tips":{
            "sub_heading":"The most enjoyable recreation is the one that's well-planned! Check out these useful tips to ensure a smooth and safe experience at Wahoo Waterworld."
        },
        "event_venue":{
            "sub_heading":"Enjoy Exciting Adventures in Every Celebration & Activity!"
        },
        "map":{
            'title':'Site Map',
            'sub_heading':"Discover the fun at Wahoo Waterworld effortlessly!"
        },
        "service":{
            "heading_service":"Service",
            "heading_facilities":"Facilities",
            "fasilitas_sub_heading":"Various kinds of comfortable and clean facilities!"
        },
        "menus":{
        "things_to_do": "Things To Do",
        "dining": "Dining",
        "services_facilities":"Service and Facilities",
        "event_venue":"Event Venue",
        "plan_your_visit":"Plan Your Visit",
        "getting_here": "Getting Here",
        "plan_your_event":"Plan Your Event",
        "map":"Map",
        "accomodation":"Accomodation",
        "tips": "Tips",
        "tips_on_wahoo":"Tips On Wahoo",
        "faq": "FAQ",
        "rules": "Rules",
        "term_and_condition":"Terms and Conditions",
        "tickets_and_packages":"Tickets and Package",
        "tiket_pass":"Ticket Pass",
        "ride_and_attractions": "Ride and Attractions",
        "buy_tickets":"Buy Tickets",
        "article":"Article",
         "bookPage":'Booking',
        "specialOffer":"Special Offer"
      },
      "other_attraction":"Other Attractions",

      "open_hour":"Opening Hours",
      "ceklis_setuju" :"Please ensure you understand and accept the terms and conditions of ticket purchase. All ticket purchases are non-refundable.",
      "setuju_sebelum_lanjut":"Agree to the terms & conditions before continuing",
      
      "tiket_note": "Prices may change at any time without prior notice",
      "tickets":"Tickets",
      "learn_more":"Learn More",
      "booking":'Group Booking',
      "guest_service":"Guest Services",
      "attraction":"Attractions",
      "room_package":"Room Package",
      "book_now":"Book Now!",
      "see_more": "See More",
      "online_reservation":"Online Reservation",
      "guest_service_and_facilities":"Guest Service & Facilities",
      "event_venues" :"Event & Venues",
      "special_offer":"Special Offer",
      "rules_and_regulation":"Rules & Regulation",
      "article":"Article",
      "contact_us":"Contact Us",
      "drench":"Drench",
      "thrill":"Thrill",
      "speed":"Speed",
      "rides_type":"Rides Type",
      "batasan_atraksi":"Attraction Restrictions",
      "caution":"Caution",
      "cahsless_payment":`      <span>C</span>
                                <span>a</span>
                                <span>s</span>
                                <span>h</span>
                                <span>l</span>
                                <span>e</span>
                                <span>s</span>
                                <span>s</span>
                                <span>&nbsp;</span>
                                <span>P</span>
                                <span>a</span>
                                <span>y</span>
                                <span>m</span>
                                <span>e</span>
                                <span>n</span>
                                <span>t</span>
                                <span>s</span>`


}
export default en;
